import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { AutocompleteService } from './autocomplete.service';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit {
  
  field: FieldConfig;
  group: FormGroup;
  myControl = new FormControl();
  valueSelected:any;
  filteredOptions:any;
  inputValue:string='';

  @Input() listenKeyup;
  
  constructor(private autocompleteService: AutocompleteService) {
    this.field = {type: 'autocomplete', name: '', label: '', value: '', select: {options:[]}, validations: []};

    this.autocompleteService.selectdataListSubscription().subscribe(
      dataList => {
        this.field.select.options=dataList;
        this.updateList();
      }
    )
  }
  
  ngOnInit(): void {
    this.filteredOptions =[];
    this.filteredOptions = this.field.select.options;
    this.inputValue='';
    
  }

  filter(key){
 
    this.filteredOptions=[];
    for (const elem of this.field.select.options) {
      if(elem.name.toLowerCase().includes(key.toLowerCase())){
        this.filteredOptions.push(elem)
      }      
    }
  }

 

  selected(fieldName,option){
    this.valueSelected=option;
    this.autocompleteService.onSelectionChange({fieldName,option});
  }


  keyup(fieldName,value,options){
    this.autocompleteService.onKeyUp({fieldName,value,options});
  }

  updateList(){
    this.filteredOptions=[];
    for (const elem of this.field.select.options) {
      this.filteredOptions.push(elem)
    }     
  }
}
